let Common = {
  header: ["Home", "Services", "About", "Recent Projects", "Contact"],
  carouselText: `LEADERS IN QUALITY CONSTRUCTION AND INFRASTRUCTURE`,
  services: "SERVICES",
  servicesText: {
    preconstructionPlanning: "Preconstruction Planning",
    preconstructionPlanningText:
      "We thoroughly assess and plan to mitigate risks associated with constructing the project, including evaluation of the construction site, permit and inspection requirements, and any other special situations that need to be resolved before or during construction",
    architectureModeling: "Architecture Modeling",
    architectureModelingText:
      "A good home design considers all aspects of the site and building – orientation, site features, thermal performance, floor plan, materials, finishes, technologies, appliances, and landscape. Using a qualified architect we ensure good design, better quality outcomes and a smoother construction process.",
    contructionManagement: "Contruction Management",
    contructionManagementText:
      "It is essential to effectively oversee on-site operations, such as personnel and materials to ensure quality builds. We plan, coordinate, budget, and supervise the project from start to finish.",
  },
  aboutUs: "ABOUT US",

  aboutUsText1AmazingBuilder:
    "Welcome to Amazing Master Builder, where quality construction meets unwavering dedication. With 5 years of expertise, we specialize in residential, commercial, and industrial projects. Our commitment to excellence, safety, and sustainability ensures superior results on time and within budget. We prioritize clear communication and personalized service, partnering closely with clients to bring their vision to life. At Amazing Master Builder, integrity and professionalism are at the core of everything we do. Trust us to deliver exceptional construction solutions tailored to your needs. Experience the difference with Amazing Master Builder – your trusted partner in construction excellence.",
  aboutUsText1AmazingConcept:
    "Welcome to Amazing Concept Builder, where quality construction meets unwavering dedication. With 5 years of expertise, we specialize in residential, commercial, and industrial projects. Our commitment to excellence, safety, and sustainability ensures superior results on time and within budget. We prioritize clear communication and personalized service, partnering closely with clients to bring their vision to life. At Amazing Concept Builder, integrity and professionalism are at the core of everything we do. Trust us to deliver exceptional construction solutions tailored to your needs. Experience the difference with Amazing Concept Builder – your trusted partner in construction excellence.",
  recentProjects: "RECENT PROJECTS",
  recentProjectsArray: [
    "Project 1 - Hartland 25",
    "Project 2 - Sandygate 27",
    "Project 3 - Restful 22",
    "Project 4 - Grazing",
  ],
  partners: "PARTNERS",
  contact: "CONTACT",
  inquiry: "Inquiries",
  inquiryText:
    "For any inquiries, questions or commendations, please <br /> call: <strong>0430 454 071</strong> or fill out the following form",
  headOffice: "Head Office",
  headOfficeAddress: `9/7 Greaves street, <br /> Dandenong VIC 3175`,
  headOfficeMailAmazingMaster: "amazingmasterbuilders.com.au",
  headOfficeMailAmazingConcept: "amazingconceptbuilders.com.au",

  headOfficeTelephone: "Tel: 0430 454 071",
  employement: "Employment",
  exmployementTextAmazingMaster:
    "To apply for a job with Amazing Master Builds, please send a cover letter together with your C.V. to: info@amazingmasterbuilders.com.au",
  exmployementTextAmazingConcept:
    "To apply for a job with Amazing Concept Builds, please send a cover letter together with your C.V. to: info@amazingconceptbuilders.com.au",
  getA_Qoute: "Get a quote: 0430 454 071",
  socialMedia: "Socials/Media",

  copywriteTextAmazingMaster: "by Amazing Master Builders.",
  copywriteTextAmazingConcept: "by Amazing Concept Builders.",
  prjectsDetail1:
    "<strong> Seamless Sophistication </strong> - Step inside our newly finished single-story dwelling, where elegance meets comfort.",
  prjectsDetail2:
    "The interiors are thoughtfully designed to elevate your everyday living experience. Immerse yourself in the harmony of timeless style and modern functionality without the designer price tag.",
  contactUs: "Contact Us",
  firstName: "First Name",
  lastName: "Last Name",
  email: "Email",
  subject: "Subject",
  message: "Message",
  submit: "Submit",
  HarlandText: "Hartland 25",
  SandyGateText: "Sandygate 27",
  RestfulText: "Restful 22",
  GrazingText: "Grazing",
  projectHarlandText: "Project 1 - Hartland 25",
  projectSandyGateText: "Project 2 - SandyGate 27",
  projectRestfulText: "Project 3 - Restful 22",
  projectGrazingText: "Project 4 - Grazing",
  servicesImg1:
    "https://static.wixstatic.com/media/c19c76_22d8ec47d1484b09a9c333e4141a12a0.jpg/v1/fill/w_300,h_225,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/c19c76_22d8ec47d1484b09a9c333e4141a12a0.jpg",
  servicesImg2:
    "https://static.wixstatic.com/media/1717c1a97d9c4914a55aee50264fe642.jpg/v1/fill/w_300,h_225,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/Architecture%20Model%20Sketching.jpg",
  servicesImg3:
    "https://static.wixstatic.com/media/11062b_9456ae21da904e56a64172fc4028f12d~mv2.jpg/v1/fill/w_300,h_225,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/New%20Houses.jpg",
  instaLogo:
    "https://static.wixstatic.com/media/11062b_6e9638ad803e4099a6116eb750b5a584~mv2.png/v1/fill/w_63,h_63,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/11062b_6e9638ad803e4099a6116eb750b5a584~mv2.png",
  fbLogo:
    "https://static.wixstatic.com/media/11062b_366f7fdbcafc4effaeddb0dba92014c1~mv2.png/v1/fill/w_63,h_63,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/11062b_366f7fdbcafc4effaeddb0dba92014c1~mv2.png",
  tiktokLogo:
    "https://static.wixstatic.com/media/11062b_ad1a1e62a5bb45c7835a3ec11d5188f2~mv2.png/v1/fill/w_63,h_63,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/11062b_ad1a1e62a5bb45c7835a3ec11d5188f2~mv2.png",
  colors: {
    yellow: "yellow",
  },
};

export default Common;
